import React from "react";
import ProgramPage from "../../components/ProgramPage";

export default function PiecesOfHope() {
    return (
        <ProgramPage
            eyebrow="A Program of The Gift of Kindness"
            title="Pieces of Hope"
            subtitle="An Autism Awareness Program"
            tagline="Every piece matters. Every child is a masterpiece."
            hero_image="https://images.unsplash.com/photo-1596079890744-c1a0462d0975?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            intro="Pieces of Hope exists to walk beside families, caregivers, and children on the autism spectrum — celebrating every mind exactly as it was made and refusing to let any family feel alone in the journey."
            body_paragraphs={[
                "Autism is not a puzzle to be solved — it's a picture to be understood. Pieces of Hope creates safe spaces where children can be themselves, where parents can breathe, and where communities can learn how to love better.",
                "Through sensory-friendly events, family gatherings, resource sharing, and honest conversation, we invite the whole community into the work of belonging. Because every child deserves a room that was built for them.",
                "We partner with therapists, teachers, siblings, and neighbors — the people who show up every day — to make our schools, churches, and public spaces places where every child feels welcome.",
            ]}
            pillars={[
                { t: "Sensory-Friendly Gatherings", b: "Quiet lights, calm rooms, joyful play — designed with sensory needs in mind so every family can show up as they are." },
                { t: "Family Support", b: "Parent circles, sibling programs, and one-to-one encouragement so no caregiver walks the road alone." },
                { t: "Awareness & Advocacy", b: "Speaking to schools, churches, and businesses about how to make everyday spaces welcoming for neurodivergent children." },
            ]}
            verse={{
                text: "I praise You because I am fearfully and wonderfully made.",
                attribution: "Psalm 139:14",
            }}
            cta_text="Get Involved"
        />
    );
}
